import { IconButton as MaterialIconButton, useTheme } from '@mui/material';
import React from 'react';

import type { Theme } from '../../themes/themes';
import { getStyles } from './IconButton.styles';
import type { IconButtonComponent, IconButtonProps } from './IconButton.types';

/**
 * The IconButton
 *
 * @version [AIV]{version}[/AIV]
 * @author [SFP](https://gitlab.sfp.berlin/products/sparkasse.de/portals)
 * @see [https://styleguide.sparkasse.de/document/69#/form-komponenten/iconbutton]
 */
export const IconButton = React.forwardRef(
  ({ children, disablePadding, circular = false, sx: externalSx, ...props }, ref) => {
    const theme = useTheme<Theme>();
    const styles = getStyles(theme);
    // Combine internal sx based on props
    const computedSx = {
      ...(disablePadding ? styles.disablePadding : {}),
      ...(circular ? styles.circular : {}),
    };

    // Merge internal sx with external sx provided via props
    // External styles will override internal ones if keys conflict
    const finalSx = { ...computedSx, ...externalSx };

    return (
      <MaterialIconButton sx={Object.keys(finalSx).length !== 0 ? finalSx : undefined} {...props} ref={ref}>
        {children}
      </MaterialIconButton>
    );
  }
) as IconButtonComponent<IconButtonProps>;

IconButton.displayName = 'ref(IconButton)';
